import { gql } from '@apollo/client';

export const GetOrganizationGuestUsers = gql`
  query GetOrganizationGuestUsers($organizationCode: String!, $contactDetails: String, $first: Int, $offset: Int) {
    organizationGuestUsers(organizationCode: $organizationCode, contactDetails: $contactDetails, first: $first, offset: $offset) {
      edges {
        node {
          immutableId
          firstName
          lastName
          email
          status
          avatar {
            initials
            color
          }
        }
      }
      pageInfo {
        hasNextPage
      }
      totalCount
    }
  }
`;
